
export class W2Model {
    w2Items: W2Item[];

    constructor() {
        this.w2Items = new Array<W2Item>();
    }
}

export class W2Item {
    w2ID: number;
    fileName: string;
    linkText: string;
    fileType: string;
    createdOn: string;
    year: number;


    constructor() {
        this.w2ID = 0;
        this.fileName = null;
        this.linkText = null;
        this.fileType = null;
        this.createdOn = null;
        this.year = 0;

    }
}

export class W2EmailCriteria {
    toAddress: string;
    w2ID: number;
    constructor() {
        this.w2ID = 0;
        this.toAddress = null;
    }
}